import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import userSlice from './slices/userSlice';
import uiSlice from './slices/uiSlice';
import themeSlice from './slices/themeSlice';
import authReducer from '../redux/reducers/authReducer';
import logoReducer from '../redux/reducers/logoReducer';
import oemReducer from '../redux/reducers/oemReducer';
import profileReducer from '../redux/reducers/profileReducer';
import customerReducer from '../redux/reducers/customerReducer';
import transactionReducer from '../redux/reducers/transactionReducer';
import multipleDomainReducer from '../redux/reducers/multipleDomainReducer';
import scanReducer from '../redux/reducers/myDomainScanReducer';
import scanListReducer from '../redux/reducers/scanListReducer';
import singleScanReducer from '../redux/reducers/singleScanReducer';
import dashboardReducer from '../redux/reducers/dashboardReducer/dashboardReducer';
import rootSaga from '../redux/sagas/rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    user: userSlice,
    ui: uiSlice,
    theme: themeSlice,
    auth: authReducer,
    logo: logoReducer,
    oem: oemReducer,
    profile: profileReducer,
    customer: customerReducer,
    transaction: transactionReducer,
    multipleDomain: multipleDomainReducer,
    scanList: scanListReducer,
    scan: scanReducer,
    singleScan: singleScanReducer,
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: ['persist/PERSIST']
      }
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;